import { useState } from "react";
import { serializeObject } from "../serialize";

export const useForms = (callback) => {
  const [values, setValues] = useState([]);

  // we receive as a callback the validation function
  const handleSubmit = (event) => {
    console.log("handleSubmit", values, event);
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    callback(values);
  };

  // all the changes pass through the serializer so we can send values as an object.
  // the field name will be the 'name' property of the input
  const handleChange = (form) => {
    console.log("handleChange", form, values);
    callback(values);
    setValues(serializeObject(form));
  };

  return {
    handleChange,
    handleSubmit,
    values,
  };
};
